/* eslint-disable no-shadow */

const state = {
  nowSpecification: 'single',
};

const actions = {
  async saveEditElement({
    commit
  }, data) {
    const tmps = await new Promise((resolve, reject) => {
      resolve(data)
    }).then((data) => {
      return data;
    })
    return tmps;
  },
  async searchEle({
    commit
  }, data) {
    const tmps = await new Promise((resolve, reject) => {
      resolve([{
        code: "hello",
        name: "sdf",
        class1: "Sdf",
        class2: "ss",
        uid: "!233333",
        cargo: 1
      }, {
        code: "hello2",
        name: "sdf2",
        class1: "Sdf2",
        class2: "ss2",
        uid: "!233332",
        cargo: 0
      }])
    }).then((data) => {
      return data;
    })
    return tmps;
  }
};

const mutations = {
  setSpecification(state, data) {
    state.nowSpecification = data;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
